module.exports = __webpack_public_path__ + "static/media/hero.b5a70d6c.mp4";